import React from 'react';
import './App.css';
import Form from './Form'
import Resultat from './Resultat'

class App extends React.Component {

  constructor (props){
    super (props)
    this.state = {
      installation: "",
      montant: "",
      imposable: "",
      resultat: null
    }
  }

  setMontant = ( montant ) => {
    console.log (montant) 
    if (isNaN(montant) === false) {
      this.setState ({ montant: montant, resultat: null })
    }
  }

  setImposable = (imposable) => {
    this.setState ({ imposable: imposable, resultat: null })
  }

  setInstallation  = ( numeroInstallation) => {
    this.setState ({ installation: numeroInstallation, resultat: null })
  }

  calculer = () => {
    const { montant, imposable, installation } = this.state;

    if ( (montant === "") || (imposable === "") || (installation === "")) {
      this.setState ({ resultat : { hasError: true, message: "Tous les champs sont obligatoires" }})
    } else {
      let cout = parseInt(montant)
      let aide = 0;
      let max;

      if (installation ==="1"){
        // pour l'eau chaude uniquement
        if (imposable === "oui"){
          max = 2000;
        } else {
          max = 2500;
        }
      } else {
        // pour l'eau chaude et le chauffage
        if (imposable === "oui"){
          max = 4500;
        } else {
          max = 5000;
        }        
      }

      if ( cout > max) aide = max
      else aide = cout

      this.setState({ resultat: { hasError: false, aide: aide, installation: installation, imposable: imposable } })
    }
  }

  render () {
    const {installation, montant, imposable, resultat } = this.state;

    console.log (this.state)

    return (
      <div className="App container">
        <Form 
          installation={installation}
          montant = {montant}
          imposable = {imposable}
          setMontant = { this.setMontant}
          setImposable = { this.setImposable}
          setInstallation = { this.setInstallation }
          setResultat = { () => this.setResultat}
        />
        <div className="text-center"  style={{ marginBottom:"15px"}}>
          <button className="btn btn-primary mb-3" onClick={ () => this.calculer () }>Calculer</button>
        </div>     
        {resultat && <Resultat {...resultat}/>}   
      </div>
    );
  }
}

export default App;
